import { gql } from '@apollo/client'

export type { VerifyAccount, VerifyAccountVariables } from './types/index.graphql'
export type { Login, LoginVariables } from './types/index.graphql'

export const VERIFY_ACCOUNT = gql`
  mutation VerifyAccount($token: String!) {
    verifyAccount(token: $token) {
      success
    }
  }
`

export const LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      success
      token
      user {
        id
        name
        lastName
        email
        organizationRole {
          organization {
            id
            name
          }
        }
      }
    }
  }
`
